var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2AA9E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.364 12.239c.006.14.01.28.01.423 0 4.339-3.302 9.341-9.341 9.341A9.285 9.285 0 0 1 8 20.528c.258.03.519.045.783.045 1.54 0 2.954-.523 4.077-1.404a3.286 3.286 0 0 1-3.066-2.28 3.252 3.252 0 0 0 1.482-.056 3.286 3.286 0 0 1-2.633-3.22v-.04c.443.246.949.393 1.487.41a3.282 3.282 0 0 1-1.46-2.733c0-.601.163-1.165.445-1.65a9.32 9.32 0 0 0 6.765 3.43 3.282 3.282 0 0 1 5.593-2.995 6.586 6.586 0 0 0 2.086-.796 3.288 3.288 0 0 1-1.444 1.815A6.534 6.534 0 0 0 24 10.54a6.66 6.66 0 0 1-1.636 1.7z",
    fill: "#fff"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.8e261b51.svg";
export { ForwardRef as ReactComponent };